import { useStaticQuery, graphql } from 'gatsby'
import { GraphqlMarkdownNodeI, GraphqlMarkdownI, AllFileQueryI } from '../types/common'
import { PostI } from '../types/data-models'

interface UsePostsQueryI {
  posts: GraphqlMarkdownI<PostI>
  coverImages: AllFileQueryI
  thumbnails: AllFileQueryI
}

const usePosts = (): UsePostsQueryI => {
  const { posts, coverImages, thumbnails } = useStaticQuery(
    graphql`
      query {
        posts: allMarkdownRemark(
          filter: { fields: { type: { eq: "POST" } }, frontmatter: { isDraft: { eq: false } } }
        ) {
          edges {
            node {
              excerpt
              frontmatter {
                isDraft
                isFeatured
                title
                subtitle
                description
                category
                tags
                coverImage {
                  label
                  url
                }
              }
              fields {
                slug
              }
            }
          }
        }
        thumbnails: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            node {
              relativePath
              sourceInstanceName
              childImageSharp {
                gatsbyImageData(width: 480, quality: 100, placeholder: BLURRED)
              }
              publicURL
            }
          }
        }
      }
    `
  )
  return { posts, coverImages, thumbnails }
}

export const getPostsByCategory = (categoryName: string): GraphqlMarkdownNodeI<PostI>[] => {
  const { posts } = usePosts()
  const filteredPostsByCategory = posts.edges.filter((postItem) => postItem.node.frontmatter.category === categoryName)
  return filteredPostsByCategory
}

export const getPostsWithTag = (tagName: string): GraphqlMarkdownNodeI<PostI>[] => {
  const { posts } = usePosts()
  const postsWithTag = posts.edges.filter((postItem) => postItem.node.frontmatter.tags?.includes(tagName))
  return postsWithTag
}

export const getOtherPostsInTheCategory = (
  categoryName: string,
  currentPost: string
): GraphqlMarkdownNodeI<PostI>[] => {
  const { posts } = usePosts()
  const otherPostsInTheCategory = posts.edges
    .filter((postItem) => postItem.node.frontmatter.category === categoryName)
    .filter((currentPostInCategory) => currentPostInCategory.node.frontmatter.title !== currentPost)
  return otherPostsInTheCategory
}

export default usePosts
